import { render } from "./ds-npot-par-view.vue?vue&type=template&id=1b184048&scoped=true"
import script from "./ds-npot-par-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-npot-par-view.vue?vue&type=script&setup=true&lang=js"

import "./ds-npot-par-view.vue?vue&type=style&index=0&id=1b184048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b184048"],['__file',"src/views/tep/tep-nsi/ds-npot-par-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b184048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b184048', __exports__)) {
    api.reload('1b184048', __exports__)
  }
  
  module.hot.accept("./ds-npot-par-view.vue?vue&type=template&id=1b184048&scoped=true", () => {
    api.rerender('1b184048', render)
  })

}


export default __exports__